<template>
  <div class="c-attach-settings" @click="close">
    <div v-if="item?.id" :class="{'hidden': !item?.id}" class="pinned">
      <div class="pinned-schedule">Прикрепленный шаблон настроек: {{ item?.title }}</div>
    </div>
    <div class="buttons-wrapper">
      <n-button v-if="item?.id" class="apply-btn" @click.stop="unlink">Открепить от шаблона</n-button>
      <n-button class="apply-btn" @click.stop="show = true">Прикрепить шаблон</n-button>
    </div>
    <div v-if="show" class="c-add-visit">
      <n-loader :loading="$var('load')" />
      <div class="form" @click.stop>
        <div class="title main">Выберите шаблон настроек</div>
        <n-input v-model="search" class="search-input" placeholder="Поиск" />
        <div class="schedule-list">
          <div v-for="schedule in filtered" :key="schedule.id" class="schedule-row" @click="selected = schedule">
            <div class="left">
              {{ schedule.title }}
            </div>
            <div class="right">
              <div class="circle" :class="{'active': schedule.id === selected.id}" />
            </div>
          </div>
        </div>
        <div class="buttons">
          <n-button class="cancel" @click="close">Отмена</n-button>
          <n-button :disabled="!Object.keys(selected).length > 0" @click="apply">Прикрепить</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import imgDone from '../../assets/done.svg'


export default {
  name: 'CAttachSettings',
  props: {
    type: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    modelId: {
      required: true,
    },
  },
  data() {
    return {
      imgDone,
      show: false,
      selected: {},
      schedules: [],
      useHiredDate: false,
      forceRefactoring: false,
      applyDate: new Date(),
      search: '',
      showInfo: false,
    }
  },
  computed: {
    filtered() {
      const query = this.search.toLowerCase()
      return $n.filter(this.schedules, (schedule) =>
        schedule.title.toLowerCase().includes(query)
      )
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.load()
      }
    },
  },
  created() {
  },
  methods: {
    close() {
      this.show = false
      this.selected = {}
      this.useHiredDate = false
      this.applyDate = new Date()
    },
    apply() {
      const data = {
        modelType: this.type,
        modelId: this.modelId,
        templateId: this.selected.id,
      }
      this.$var('load', true)
      $api.settingsTemplates.attach(data).then(() => {
        this.$emit('done')
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    unlink() {
      const data = {
        modelType: this.type,
        modelId: this.modelId,
      }
      this.$var('load', true)
      $api.settingsTemplates.unlink(data).then(() => {
        this.$emit('done')
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
    load() {
      this.$var('load', true)
      $api.settingsTemplates.get().all().then((response) => {
        this.schedules = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-attach-settings {
  display: flex;
  align-items: center;
  width: 100%;

  .search-input {
    margin-bottom: 15px;
  }
  .pinned-schedule {
    height: 48px;
    background-color: #ffffff;
    color:  var(--primary);
    border-radius: 12px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    font-weight: 500;
  }
  .pinned {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 15px;
    &.hidden {
      opacity: 0  ;
    }
  }

  .buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: right;
    flex: 1;
    .n-button {
      margin-right: 15px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .info-wrapper {
    position: relative;
    display: inline-block;

    .top-part {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      .title-top {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .types-popover {
      position: absolute;
      top: 60px;
      right: 0;
      z-index: 1000;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 12px;
      padding: 24px;
      width: 600px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

  }

  .types-wrapper {
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;

    .type {
      margin-top: 5px;
      display: flex;
      align-items: center;

      &:last-child {
        margin-right: 0;
      }

      .circle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid #dcdcdc;
        width: 32px;
        height: 32px;
        background-color: #64C038;
        margin-right: 5px;
        color: #fff;
        font-size: 14px;
      }

      .title {
        font-weight: 400;
        height: 100%;
        line-height: 1;
        color: #000000;
        font-size: 14px;
        width: 100%;
      }
    }
  }

  .field {
    flex: 1;
    display: flex;
    margin-bottom: 15px;
    .n-input {
      margin-left: 25px;
      min-width: 100px;
    }
    &.check-box {
      display: flex;
      align-items: center;
      width: 100%;
      .box {
        margin-right: 15px;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid #000000;
      }
      .title {
        justify-content: left;
        margin-bottom: 0;
      }
    }
  }
  .schedule-list {
    width: 100%;
    border-top: 2px solid #EBEBEB;
    border-bottom: 2px solid #EBEBEB;
    padding: 5px;
    margin-bottom: 15px;
    max-height: 400px;
    overflow-y: auto;
    .schedule-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
      padding: 5px;
      border-radius: 4px;
      cursor: pointer;
      background-color: rgba(235, 235, 235, 0.38);
      &:last-child {
        margin-bottom: 0;
      }
      .circle {
        background-color: #EBEBEB;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        &.active {
          background-color: var(--primary);
        }
      }
    }
  }

  .c-add-visit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    padding: 10px;
    background-color: #00000080;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .n-button {
    border: none;
    border-radius: 12px;
    min-height: 48px;
    padding: 0 24px;
    background-color: var(--primary) !important;
    color: #FFFFFF;
    &.cancel {
      color: #000000;
      background-color: #D4CFCF !important;
    }
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 400px;
    min-height: 200px;
    border-radius: 8px;
    background-color: #FFFFFF;
    border: 2px solid var(--primary);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: stretch;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
    .time-selector-wrapper {
      width: 100%;
      margin-bottom: 15px;
      .date-picker {
        max-width: 320px;
      }
      .title {
        &.danger {
          width: 100%;
          color: red;
          text-align: center;
        }
        margin-bottom: 5px;
        font-weight: normal;
        font-size: 16px;
        color: #000000;
      }
    }
    .time-selector {
      display: flex;
      align-items: center;
      justify-content: start;
      ::v-deep {
        .n-select {
          .n-icon {
            display: none;
          }
          .n-text {
            text-align: center;
          }
          &:first-child {
            margin-right: 5px;
          }
          &:last-child {
            margin-left: 5px;
          }
          width: 60px;
          .n-content {
            padding: 0;
          }
          .n-icon {
            margin: 0 !important;
          }
          .n-popup-content {
            width: 60px;
            .n-dropdown-item {
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .n-item {
              text-align: center;
            }
          }
          .n-wrapper {
            padding: 0 5px;
            width: 60px;
          }
          .n-dropdown {
            width: 60px;
          }
        }
      }
    }
  }
}
</style>
